import { Info, Lock, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

export function PageHeader({ eyebrow, title, subtitle, action }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-7">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-2 font-poppins font-semibold text-[.7rem] tracking-[.14em] uppercase text-kid-teal">
            <span className="w-1.5 h-1.5 rounded-full bg-kid-coral" /> {eyebrow}
          </span>
        )}
        <h1 className="text-3xl sm:text-4xl font-extrabold text-kid-navy mt-1">{title}</h1>
        {subtitle && <p className="text-kid-muted mt-1.5 max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function Disclaimer({ children, testid = "disclaimer" }) {
  return (
    <div className="flex gap-3 items-start bg-kid-skytint/60 border border-kid-line rounded-2xl px-4 py-3 text-[.82rem] text-kid-muted leading-relaxed" data-testid={testid}>
      <Info size={16} className="text-kid-teal shrink-0 mt-0.5" />
      <span>{children}</span>
    </div>
  );
}

const PRIORITY_STYLES = {
  high: "bg-kid-coral/12 text-kid-coral",
  medium: "bg-kid-sun/20 text-[#B07A11]",
  low: "bg-kid-sky/15 text-[#2E7CB0]",
};

export function PriorityBadge({ priority }) {
  return (
    <span className={`inline-block text-[.68rem] font-poppins font-semibold uppercase tracking-wide px-2.5 py-1 rounded-full ${PRIORITY_STYLES[priority] || PRIORITY_STYLES.medium}`}>
      {priority}
    </span>
  );
}

export function UpgradeGate({ title = "This feature is included in Family Path", body = "Upgrade to save documents, track tasks, and get more guided support." }) {
  return (
    <div className="kid-card p-10 text-center max-w-lg mx-auto" data-testid="upgrade-gate">
      <div className="w-16 h-16 rounded-2xl bg-kid-teal/10 text-kid-teal grid place-items-center mx-auto mb-5">
        <Lock size={28} />
      </div>
      <h3 className="text-2xl font-extrabold text-kid-navy mb-2">{title}</h3>
      <p className="text-kid-muted mb-6">{body}</p>
      <Link to="/app/account" className="kid-btn kid-btn-primary px-7 h-12 inline-flex" data-testid="upgrade-gate-button">
        <Sparkles size={16} /> Upgrade to Family Path
      </Link>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, body, action, testid }) {
  return (
    <div className="kid-card p-8 sm:p-10 flex flex-col sm:flex-row items-start gap-5" data-testid={testid}>
      {Icon && <div className="w-14 h-14 rounded-2xl bg-kid-skytint text-kid-teal grid place-items-center shrink-0"><Icon size={26} /></div>}
      <div className="flex-1 min-w-0">
        <h3 className="text-xl font-bold text-kid-navy mb-1.5">{title}</h3>
        <p className="text-kid-muted mb-5 max-w-2xl">{body}</p>
        {action}
      </div>
    </div>
  );
}

export function Spinner({ label = "Loading…" }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-4">
      <div className="w-10 h-10 rounded-full border-4 border-kid-line border-t-kid-teal animate-spin" />
      <p className="text-kid-muted font-poppins text-sm">{label}</p>
    </div>
  );
}
